import { Component, Directive, EventEmitter, HostListener, Injectable, Input, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmActionModalComponent } from './confirm-action-modal.component';

@Directive({
    selector: '[confirm]',
    standalone: false
})

export class ConfirmActionComponent {
   
    @Input('confirm-message') confirmMessage: string;
    @Output('confirm-action') confirmAction: EventEmitter<any> = new EventEmitter();

    constructor(public modalService: NgbModal) { }

    ngOnInit(): void {
    }

    @HostListener('click')
    open() {
   
        const modalRef = this.modalService.open(ConfirmActionModalComponent,
            { backdrop: 'static', centered: true });

        modalRef.componentInstance.message = this.confirmMessage;
        modalRef.result.then((result) => {
            if(result === true) {
                this.confirmAction.emit();
            }
          }, () => {
          });

    }

}
